<script>
	import { goto } from '$app/navigation';
	import { PUBLIC_PATH } from '$env/static/public';
	export let heroData;
</script>

<section
	id="home"
	aria-label="Hero Section"
	class="relative w-full overflow-hidden bg-gradient-to-b from-primary to-[#0c1a5a]"
>
	<!-- Background grid -->
	<div
		class="pointer-events-none absolute inset-0 opacity-[0.26] bg-repeat mix-blend-overlay"
		style="background-image: url('{PUBLIC_PATH}/images/grid-line.svg');"
	></div>
	<div
		class="relative mx-auto flex h-full max-w-8xl flex-col items-center px-padding_lg pt-[2.9375rem] lg:pt-0 lg:grid lg:grid-cols-2 lg:items-start lg:px-[3.875rem]"
	>
		<!-- Left Content -->
		<div class="flex flex-col items-center lg:py-[5.5625rem] lg:items-start">
			<!-- RBI Info Chip -->
			<div
				class="inline-flex items-center justify-center rounded-sm border border-tint24-primary bg-tint12-primary px-1 py-0.5"
			>
				<span class="body_small font-medium uppercase tracking-[0.0075rem] text-primary">
					{heroData.chipText}
				</span>
			</div>

			<!-- Title Section -->
			<div
				class="relative mt-padding_xxlg flex flex-col items-center gap-padding_xxsm lg:mt-padding_xxxlg lg:items-start"
			>
				<div
					class="absolute -left-[0.5625rem] top-0 h-[2.1875rem] w-[5.25rem] border-r-[0.1875rem] border-[#009200] bg-gradient-to-r from-[rgba(0,146,0,0.2)] to-[rgba(0,146,0,0.5)] lg:h-[3.5rem] lg:w-[10.125rem]"
				></div>

				<h1
					class="relative z-10 m-0 text-center text-[1.5rem] z-10 font-semibold leading-[2.25rem] tracking-[-0.0625rem] text-white lg:text-left lg:text-[3rem] lg:leading-[3.5rem]"
				>
					{#each heroData.titleLines as line}
						<div class="whitespace-nowrap">
							<!-- eslint-disable-next-line svelte/no-at-html-tags -->
							{@html line}
						</div>
					{/each}
				</h1>
			</div>

			<!-- Description Paragraph -->
			<p
				class="mt-padding_sm max-w-[17.625rem] text-center body_default z-10 tracking-[-0.00625rem] text-disabled lg:mt-padding_xlg lg:max-w-[34.125rem] lg:text-left lg:body_large"
			>
				{heroData.description}
			</p>

			<!-- Button -->
			<div class="mt-8 flex items-center lg:mt-space_40">
				<button
					onclick={() => {
						goto(`${PUBLIC_PATH}#products`);
					}}
					class="flex h-[2.75rem] items-center justify-center gap-padding_xsm rounded-shape-corner_sm bg-background-alt px-padding_xxlg py-padding_xlg font-medium uppercase tracking-[0.010156rem] text-primary transition-opacity hover:opacity-90"
				>
					<span class="button_small">{heroData.buttonText}</span>
					<div class="flex h-padding_lg w-padding_lg items-center justify-center overflow-hidden">
						<img src="{PUBLIC_PATH}/images/chevron-right.svg" alt="chevron-right" />
					</div>
				</button>
			</div>
		</div>

		<!-- Right Content (Desktop only) -->
		<div class="relative hidden h-full items-start lg:block">
			<div
				class="absolute -left-padding_xxlg -top-padding_lg h-[20.625rem] w-[20.625rem] rounded-full bg-background-alt/10 blur-[0.125rem]"
			></div>
			<img
				class="absolute right-0 bottom-0 h-auto w-[38.75rem] max-w-none"
				fetchpriority="high"
				src={`${PUBLIC_PATH}/${heroData.images.desktop}`}
				alt={heroData.images.alt}
			/>
		</div>

		<!-- Mobile Hero Image -->
		<div class="mt-[1.75rem] block lg:hidden">
			<img
				class="h-[15.0625rem] w-[20.625rem] max-w-none object-cover"
				src={`${PUBLIC_PATH}/${heroData.images.mobile}`}
				fetchpriority="high"
				alt={heroData.images.alt}
			/>
		</div>
	</div>
</section>
